import React, { Component } from "react";
import {
  Accordion,
  AccordionItem,
  AccordionItemButton,
  AccordionItemHeading,
  AccordionItemPanel,
} from "react-accessible-accordion";
import "react-accessible-accordion/dist/fancy-example.css";
import Footer from "../home/Footer";
import Header from "../home/Header";
import croppedDonor from "../home/assets/img/cropped-donor-1.png";
import "./Faq.css";
class Faq extends Component {
  render() {
    return (
      <>
        <>
          <Header />

          <section id="faq" className="contact" style={{ padding: "80px 0" }}>
            <div className="container">
              <div className="section-title" data-aos="fade-up">
                <h2>Frequently Asked Questions</h2>
              </div>
              <div className="row">
                <div
                  className="col-lg-12 col-md-12"
                  data-aos="fade-up"
                  data-aos-delay={300}
                >
                  <ul className="faq-list">
                    <h4>
                      <b>General FAQs</b>
                    </h4>
                    <Accordion
                      allowZeroExpanded={true}
                      preExpanded={["item-1"]}
                      className="fccFaqHeading"
                      style={{ marginTop: "1em" }}
                    >
                      <AccordionItem uuid="item-1">
                        <AccordionItemHeading>
                          <AccordionItemButton>
                            We have a database of mobile numbers can we start
                            texting everyone?
                          </AccordionItemButton>
                        </AccordionItemHeading>
                        <AccordionItemPanel>
                          <p>
                            No. You cannot simply import contacts list and start
                            sending text messages. Only when a person gives
                            express written permission, may you import their
                            number into your account and begin to text them.
                          </p>
                        </AccordionItemPanel>
                      </AccordionItem>
                      <AccordionItem>
                        <AccordionItemHeading>
                          <AccordionItemButton>
                            How do we promote our text service?
                          </AccordionItemButton>
                        </AccordionItemHeading>
                        <AccordionItemPanel>
                          <p>
                            Promote your text service through your other
                            communication channels (email, social sites,
                            PR/advertising, conversation, printed pieces, etc.)
                            and give your audience compelling reasons to opt-in.
                          </p>
                          <p>
                            Events promotions, for example, are a great way to
                            get people to your text system. Running special
                            offers has also been shown as effective methods for
                            getting people to opt-in.
                          </p>
                          <p>
                            By incorporating your text service call-to-action
                            into your regular marketing and by leveraging the
                            power of text to provide your members, attendees,
                            staff, board, and volunteers reminders and updates,
                            you can grow your opt-in list quickly.
                          </p>
                        </AccordionItemPanel>
                      </AccordionItem>
                      <AccordionItem>
                        <AccordionItemHeading>
                          <AccordionItemButton>
                            How do people opt-in?
                          </AccordionItemButton>
                        </AccordionItemHeading>
                        <AccordionItemPanel>
                          <p>Self opt-in methods:</p>
                          <ul>
                            <li>
                              By Phone – Person texts your custom keyword to
                              texting number
                            </li>
                            <li>
                              By Web Widget – Person enters their mobile number
                              into your web widget on your website.
                            </li>
                            <li>
                              By Form – Person ticks a properly formatted
                              “Opt-in to Texts” checkbox on your site or paper
                              form.
                            </li>
                            <li>
                              By Email – Person sends an email request to have
                              you add them to your opt-in list.
                            </li>
                          </ul>
                        </AccordionItemPanel>
                      </AccordionItem>
                      <AccordionItem>
                        <AccordionItemHeading>
                          <AccordionItemButton>
                            How do people opt-out?
                          </AccordionItemButton>
                        </AccordionItemHeading>
                        <AccordionItemPanel>
                          <p>
                            A person can opt-out from their phone by texting the
                            word “STOP” in the text thread.
                          </p>
                          <p>
                            If you want to remind your opt-ins how they can
                            opt-out from your text service, add the instruction
                            “STOP to opt-out.” to the end of your text messages.
                          </p>
                          <p>
                            You can also manually remove a person from your text
                            service by clicking the Manage Opt-in List button
                            within your GivBee account, searching for the person
                            by mobile number, email or name, then clicking
                            delete.
                          </p>
                        </AccordionItemPanel>
                      </AccordionItem>
                      <AccordionItem>
                        <AccordionItemHeading>
                          <AccordionItemButton>
                            Are keywords case sensitive?
                          </AccordionItemButton>
                        </AccordionItemHeading>
                        <AccordionItemPanel>
                          <p>
                            No. Your opt-in keyword is not case sensitive.
                            However, when you display your opt-in call-to-action
                            on digital or print media we recommend showing the
                            opt-in keyword in all caps and in quotes.
                          </p>
                        </AccordionItemPanel>
                      </AccordionItem>
                      <AccordionItem>
                        <AccordionItemHeading>
                          <AccordionItemButton>
                            Why and when should we use web widgets?
                          </AccordionItemButton>
                        </AccordionItemHeading>
                        <AccordionItemPanel>
                          <p>
                            Widgets are convenient for several uses including:
                          </p>
                          <ul id="faqList" style={{ listStyleL: "none" }}>
                            <li>
                              – Quick and easy way for web visitors to join your
                              text service.
                            </li>
                            <li>
                              – Easy way for people to access a specific message
                              (Donate, Directions, Survey, Wifi Info, etc.).
                            </li>
                            <li>
                              – Easy way for people to join a specific text
                              group or activity list within your system.
                            </li>
                          </ul>
                        </AccordionItemPanel>
                      </AccordionItem>
                      <AccordionItem>
                        <AccordionItemHeading>
                          <AccordionItemButton>
                            Can we add a web widget to our Facebook page?
                          </AccordionItemButton>
                        </AccordionItemHeading>
                        <AccordionItemPanel>
                          <p>
                            Web Widgets are provided as iframe code. iFrames
                            cannot be embedded directly into your Facebook page.
                            However, you can paste a link to your web widget
                            into your Facebook posts and Tweets.
                          </p>
                        </AccordionItemPanel>
                      </AccordionItem>
                      <AccordionItem>
                        <AccordionItemHeading>
                          <AccordionItemButton>
                            What kinds of things can we do with a GivBee
                            account?
                          </AccordionItemButton>
                        </AccordionItemHeading>
                        <AccordionItemPanel>
                          <p>
                            Our customers do all kinds of things with our
                            platform. Here are a few…
                          </p>
                          <ul id="faqList" style={{ listStyleL: "none" }}>
                            <li>Send reminders and invitations</li>
                            <li>– Raise funds and collect pledges</li>
                            <li>
                              – For event communication with attendees;
                              exhibitors, staff
                            </li>
                            <li>– Share links to videos and photo pages</li>
                            <li>– Communicate with internal teams</li>
                            <li>– Send coupons and offers</li>
                            <li>– Tell people their food order is ready</li>
                            <li>– Promote ticket sales</li>
                            <li>
                              – Collect feedback via text polls and surveys
                            </li>
                            <li>– Send important alerts</li>
                          </ul>
                        </AccordionItemPanel>
                      </AccordionItem>
                      <AccordionItem>
                        <AccordionItemHeading>
                          <AccordionItemButton>
                            A Sprint user is having trouble joining our text
                            service or receiving texts. How do we fix it?
                          </AccordionItemButton>
                        </AccordionItemHeading>
                        <AccordionItemPanel>
                          <p>
                            Here’s how to allow text messaging services (updated
                            3/2017):
                          </p>
                          <p id="faqPanel">
                            Sign in to sprint.com with valid username and
                            password. Click the My Preferences tab. Under Limits
                            and Permissions, select Block texts.
                          </p>
                          <p id="faqPanel">
                            Click to select the phone you wish to manage
                            settings for – a Restricted symbol indicates that
                            phone is currently restricted. You will see 6
                            options for settings for the phone.
                          </p>
                          <p id="faqPanel">
                            To unblock or allow all services, click Do not block
                            any text messages.
                          </p>
                          <p id="faqPanel">
                            Once you make your selection, the symbol will change
                            to a green Updated checkmark.
                          </p>
                          <p id="faqPanel">
                            Click Save. If updates were saved successfully you
                            will see a confirmation message.
                          </p>
                          <p id="faqPanel">
                            Turn your phone off and back on for the new settings
                            to take effect.
                          </p>
                          <p style={{ marginTop: "1em" }}>
                            Instructions are available on Sprint’s own site,
                            here:{" "}
                            <a
                              href="https://support.sprint.com/support/article/Block-restrict-or-allow-text-services-via-My-Sprint/case-fk158645-20100930-171711"
                              target="_blank"
                            >
                              {" "}
                              Sprint Support Page
                            </a>
                          </p>
                        </AccordionItemPanel>
                      </AccordionItem>
                      <AccordionItem>
                        <AccordionItemHeading>
                          <AccordionItemButton>
                            Accordion Title
                          </AccordionItemButton>
                        </AccordionItemHeading>
                        <AccordionItemPanel>
                          <p>Accordion Content</p>
                        </AccordionItemPanel>
                      </AccordionItem>
                    </Accordion>
                  </ul>
                </div>
              </div>
              <div className="row" style={{ marginTop: "4em" }}>
                <div
                  className="col-lg-12 col-md-12"
                  data-aos="fade-up"
                  data-aos-delay={300}
                >
                  <ul className="faq-list">
                    <img
                      src={croppedDonor}
                      className="img-fluid"
                      alt=""
                      data-aos="zoom-in"
                      data-aos-delay={500}
                    />
                    <h4 style={{ marginTop: "1em" }}>
                      <b>FAQs for DonorPerfect Users</b>
                    </h4>
                    <Accordion
                      allowZeroExpanded
                      preExpanded={["item-1"]}
                      className="fccFaqHeading"
                      style={{ marginTop: "1em" }}
                    >
                      <AccordionItem uuid="item-1">
                        <AccordionItemHeading>
                          <AccordionItemButton>
                            My organization uses DonorPerfect. How do we sign up
                            for DPText?
                          </AccordionItemButton>
                        </AccordionItemHeading>
                        <AccordionItemPanel>
                          <p>
                            To sign up for DPText, please contact your
                            DonorPerfect rep or call 800-220-8111.
                          </p>
                        </AccordionItemPanel>
                      </AccordionItem>
                      <AccordionItem>
                        <AccordionItemHeading>
                          <AccordionItemButton>
                            Does DPText (GivBee) overwrite data in DonorPerfect?
                          </AccordionItemButton>
                        </AccordionItemHeading>
                        <AccordionItemPanel>
                          <p>
                            If DPText finds a matching record in DonorPerfect
                            (based on a matching email) where the person’s
                            mobile number does not match, DPText will overwrite
                            the mobile number with the user’s current one.
                            DPText will also save the user’s old mobile number
                            as a previous address record within DonorPerfect.
                            DPText does not overwrite any other data found in an
                            existing DonorPerfect record.
                          </p>
                        </AccordionItemPanel>
                      </AccordionItem>
                      <AccordionItem>
                        <AccordionItemHeading>
                          <AccordionItemButton>
                            Does DPText (GivBee) create a new record in
                            DonorPerfect every time a person joins the text
                            system?
                          </AccordionItemButton>
                        </AccordionItemHeading>
                        <AccordionItemPanel>
                          <p>
                            No. DPText only creates a new DonorPerfect record
                            when it has collected the first name, last name, and
                            email address from the individual via a text-based
                            exchange before. DPText Inspire & Engage messages
                            can be set up to ask for these details.
                          </p>
                        </AccordionItemPanel>
                      </AccordionItem>
                      <AccordionItem>
                        <AccordionItemHeading>
                          <AccordionItemButton>
                            Does DPText (GivBee) pass donation data to
                            DonorPerfect?
                          </AccordionItemButton>
                        </AccordionItemHeading>
                        <AccordionItemPanel>
                          <p>
                            Although DPText (GivBee) enables you to include
                            donation links (eg. weblinks) inside the text
                            messages you send to supporters, the donation data
                            is captured and passed by your online page, not
                            DPText.
                          </p>
                        </AccordionItemPanel>
                      </AccordionItem>
                      <AccordionItem>
                        <AccordionItemHeading>
                          <AccordionItemButton>
                            Does DPText (GivBee) pass pledge data to
                            DonorPerfect?
                          </AccordionItemButton>
                        </AccordionItemHeading>
                        <AccordionItemPanel>
                          <p>
                            It can. By creating an Inspire & Engage message that
                            requires the user to provide their first name, last
                            name and email address with their Pledge Amount,
                            DPText is able to transfer the pledge information
                            into the corresponding DonorPerfect record as a new
                            Pledge.
                          </p>
                        </AccordionItemPanel>
                      </AccordionItem>
                      <AccordionItem>
                        <AccordionItemHeading>
                          <AccordionItemButton>
                            Will DPText (GivBee) accept other text-based
                            responses (such as survey replies) to DonorPerfect?
                          </AccordionItemButton>
                        </AccordionItemHeading>
                        <AccordionItemPanel>
                          <p>
                            It can. By creating a DPText Inspire & Engage
                            message that requires the user to give their first
                            name, last name and email as part of their volunteer
                            application, DPText can generate a new Contact in
                            DonorPerfect. The user’s responses to the text-based
                            application get added to the Notes field.
                          </p>
                          <p>
                            Hint: Use the DPText web widget to capture name and
                            email from the volunteer before they complete the
                            application by text.
                          </p>
                        </AccordionItemPanel>
                      </AccordionItem>
                      <AccordionItem>
                        <AccordionItemHeading>
                          <AccordionItemButton>
                            Where can I learn more about DPText pricing and
                            plans?
                          </AccordionItemButton>
                        </AccordionItemHeading>
                        <AccordionItemPanel>
                          <p>
                            You can find more about the DPText integration and
                            the plans on SofterWare’s website:
                            <a
                              href="https://www.donorperfect.com/integrations/email-marketing/dp-text/"
                              target="_blank"
                            >
                              {" "}
                              https://www.donorperfect.com/integrations/email-marketing/dp-text/
                            </a>
                          </p>
                        </AccordionItemPanel>
                      </AccordionItem>
                      <AccordionItem>
                        <AccordionItemHeading>
                          <AccordionItemButton>
                            Donations are not showing up in the DonorPerfect
                            Giving Meter. Why not?
                          </AccordionItemButton>
                        </AccordionItemHeading>
                        <AccordionItemPanel>
                          <p>
                            If donations are not appearing on the meter, it
                            means one of the following is happening
                          </p>
                          <ol>
                            <li>
                              {" "}
                              No donations have been made to the selected
                              campaign for the chosen dates.
                            </li>
                            <li>
                              Your donations source settings or date range is
                              incorrect. Please check all settings (GL,
                              Campaign, Solicitation, Sub Solicitation)
                              carefully.
                            </li>
                            <li>
                              Donations are not set to auto download into
                              DonorPerfect. You can modify that setting in your
                              DonorPerfect account.
                            </li>
                          </ol>
                        </AccordionItemPanel>
                      </AccordionItem>
                    </Accordion>
                  </ul>
                </div>
              </div>
              <div className="row" style={{ marginTop: "4em" }}>
                <div
                  className="col-lg-12 col-md-12"
                  data-aos="fade-up"
                  data-aos-delay={300}
                >
                  <ul className="faq-list">
                    <h4>
                      <b>FAQs for Neon CRM users</b>
                    </h4>
                    <Accordion
                      allowZeroExpanded
                      preExpanded={["item-1"]}
                      className="fccFaqHeading"
                      style={{ marginTop: "1em" }}
                    >
                      <AccordionItem uuid="item-1">
                        <AccordionItemHeading>
                          <AccordionItemButton>
                            Where do I find my NeonCRM Org ID and API key so I
                            can connect my NeonCRM and GivBee accounts.
                          </AccordionItemButton>
                        </AccordionItemHeading>
                        <AccordionItemPanel>
                          <p>
                            Go here:
                            <a
                              href="https://developer.neoncrm.com/api/getting-started/api-keys/"
                              target="_blank"
                            >
                              {" "}
                              https://developer.neoncrm.com/api/getting-started/api-keys/
                            </a>
                          </p>
                        </AccordionItemPanel>
                      </AccordionItem>
                      <AccordionItem>
                        <AccordionItemHeading>
                          <AccordionItemButton>
                            Does GivBee overwrite exiting NeonCRM data?
                          </AccordionItemButton>
                        </AccordionItemHeading>
                        <AccordionItemPanel>
                          <p>
                            No. NeonCRM is the system of record. GivBee only
                            creates new records and adds new data. It does not
                            overwrite data inside an existing record.
                          </p>
                        </AccordionItemPanel>
                      </AccordionItem>
                      <AccordionItem>
                        <AccordionItemHeading>
                          <AccordionItemButton>
                            Does GivBee create a new record everytime a person
                            joins my text service?
                          </AccordionItemButton>
                        </AccordionItemHeading>
                        <AccordionItemPanel>
                          <p>
                            No. GivBee only creates a new NeonCRM record when no
                            matching record is found. GivBee must collect the
                            first name, last name, and email address before it
                            will create a new record in NeonCRM. Without this
                            user data, GivBee will not create a new record.
                          </p>
                        </AccordionItemPanel>
                      </AccordionItem>
                      <AccordionItem>
                        <AccordionItemHeading>
                          <AccordionItemButton>
                            How long after a donation is made (or a text
                            exchange occurs), does GivBee pass the data to
                            NeonCRM?
                          </AccordionItemButton>
                        </AccordionItemHeading>
                        <AccordionItemPanel>
                          <p>
                            Data exchanges between GivBee and NeonCRM occur
                            within a few seconds of the text exchange. See FAQ
                            above for more.
                          </p>
                        </AccordionItemPanel>
                      </AccordionItem>
                      <AccordionItem>
                        <AccordionItemHeading>
                          <AccordionItemButton>
                            Does GivBee pass donation data into NeonCRM.
                          </AccordionItemButton>
                        </AccordionItemHeading>
                        <AccordionItemPanel>
                          <p>
                            Yes. GivBee passes donation information to NeonCRM.
                          </p>
                        </AccordionItemPanel>
                      </AccordionItem>
                      <AccordionItem>
                        <AccordionItemHeading>
                          <AccordionItemButton>
                            How do we know which records in NeonCRM were created
                            by GivBee?
                          </AccordionItemButton>
                        </AccordionItemHeading>
                        <AccordionItemPanel>
                          <p>
                            Records created by GivBee show “GivBee Texting” in
                            NeonCRM’s Origin Detail field.
                          </p>
                        </AccordionItemPanel>
                      </AccordionItem>
                      <AccordionItem>
                        <AccordionItemHeading>
                          <AccordionItemButton>
                            Does GivBee support recurring donations?
                          </AccordionItemButton>
                        </AccordionItemHeading>
                        <AccordionItemPanel>
                          <p>
                            Recurring donations are supported through Neon
                            donation pages that can be used with your GivBee
                            text messaging, but not via the PayPal payment
                            feature in GivBee.
                          </p>
                        </AccordionItemPanel>
                      </AccordionItem>
                      <AccordionItem>
                        <AccordionItemHeading>
                          <AccordionItemButton>
                            Where can I learn more about the integration between
                            Givbee and Neon?
                          </AccordionItemButton>
                        </AccordionItemHeading>
                        <AccordionItemPanel>
                          <p>
                            Click here to learn more about the GivBee/NeonCRM
                            integration.{" "}
                            <a
                              href="https://www.givbee.com/wp-content/uploads/2018/12/GivBee_NeonCRMIntegration.pdf"
                              target="_blank"
                            >
                              GivBee/NeonCRM integration
                            </a>
                          </p>
                        </AccordionItemPanel>
                      </AccordionItem>
                    </Accordion>
                  </ul>
                </div>
              </div>
              <div className="row" style={{ marginTop: "4em" }}>
                <div
                  className="col-lg-12 col-md-12"
                  data-aos="fade-up"
                  data-aos-delay={300}
                >
                  <ul className="faq-list">
                    <h4>
                      <b>Helpful Hints</b>
                    </h4>
                    <Accordion
                      allowZeroExpanded
                      preExpanded={["item-1"]}
                      className="fccFaqHeading"
                      style={{ marginTop: "1em" }}
                    >
                      <AccordionItem uuid="item-1">
                        <AccordionItemHeading>
                          <AccordionItemButton>
                            Top 10 hints for successful texting and keeping the
                            people on your tet list happy.
                          </AccordionItemButton>
                        </AccordionItemHeading>
                        <AccordionItemPanel>
                          <ol>
                            <li>
                              {" "}
                              Always practice respectful texting by knowing and
                              living up to your frequency commitment (ie. up to
                              3 messages/month) and never send texts at off
                              hours.
                            </li>
                            <li>
                              Test your text messages on your own phone before
                              sending to your list.
                            </li>
                            <li>
                              If a person asks you to add them to the opt-in
                              list, do not wait too long. Opt the person in
                              before he/she has time to forget what they’ve
                              signed up for.
                            </li>
                            <li>
                              Always remind your opt-ins to practice safe and
                              responsible texting. For example, they should
                              never send or read texts while driving.
                            </li>
                            <li>
                              When possible, add the words “Reply STOP to quit”
                              into your push messages, to remind people how to
                              opt-out.
                            </li>
                            <li>
                              Review your initial opt-in greeting message
                              regularly. Is it current and still relevant?
                            </li>
                            <li>
                              When promoting your service on a web page or
                              printed promotion, tell people what they can
                              expect to receive from your organization through
                              the text service.
                            </li>
                            <li>
                              Optimize your web forms before you send its link
                              in your text message. Web pages should always be
                              mobile optimized. Hint: Simplify that form as much
                              as possible!
                            </li>
                            <li>
                              Convert long links into short links using free
                              services like bitly and tinyurl.
                            </li>
                            <li>
                              Mix it up! Keep your texting content fresh and fun
                              to keep your audience interested, active and
                              opted-in.
                            </li>
                          </ol>
                        </AccordionItemPanel>
                      </AccordionItem>
                      <AccordionItem>
                        <AccordionItemHeading>
                          <AccordionItemButton>
                            Where else can I find more information on texting
                            best practices?
                          </AccordionItemButton>
                        </AccordionItemHeading>
                        <AccordionItemPanel>
                          The Mobile Marketing Association (MMA) has produced a
                          guide to implementing short code programs. Get it
                          here:
                          <a
                            href="https://www.mmaglobal.com/documents/us-consumer-best-practices"
                            target="_blank"
                          >
                            {" "}
                            “The MMA Consumer Best Practices (CBP) for
                            Messaging”
                          </a>
                        </AccordionItemPanel>
                      </AccordionItem>
                    </Accordion>
                  </ul>
                </div>
              </div>
            </div>
          </section>
          <Footer />
        </>
      </>
    );
  }
}

export default Faq;
